module.exports = __webpack_public_path__ + "img/cabins--icon.ddf19542.svg";